import React, { Component, Fragment } from 'react'
import Table from '@material-ui/core/Table'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import MediaQuery from 'react-responsive'
import buildUrl from '../utils/apiHelpers'
import TableHead from 'components/Table/TableHead'
import UrlTableRow from 'components/Urls/Desktop/UrlTableRow'
import MobileUrlTableRow from 'components/Urls/Mobile/MobileUrlTableRow'
import UrlsDropdownFilter from 'components/Urls/UrlsDropdownFilter'
import PinkLinkButton from 'components/atoms/buttons/PinkLinkButton'
import GrayLinkButton from 'components/atoms/buttons/GrayLinkButton'

class ImportedUrlsContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      gridTemplateColumns: '8fr 2fr 240px 2fr 1fr',
      selected: 'All',
      rowsPerPage: 12,
      page: 0,
      sortBySubmittedAt: 'DESC'
    }

    this.renderTableRows = this.renderTableRows.bind(this)
    this.renderNoUrlsMessage = this.renderNoUrlsMessage.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.setUrls = this.setUrls.bind(this)
    this.renderNoUrlsWithChosenStatus = this.renderNoUrlsWithChosenStatus.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    this.handleSortBySubmittedAt = this.handleSortBySubmittedAt.bind(this)
  }

  handleSelectChange (selectedOption) {
    this.setState({ selected: selectedOption.value })
  }

  handleChangeRowsPerPage (event) {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 })
  }

  handleChangePage (event, newPage) {
    this.setState({ page: newPage })
  }

  handleSortBySubmittedAt () {
    const sortBySubmittedAt = this.state.sortBySubmittedAt === 'DESC' ? 'ASC' : 'DESC'
    this.setState({ sortBySubmittedAt: sortBySubmittedAt })
  }

  setUrls () {
    if (this.state.selected === 'All') {
      return this.props.urls
    }
    return this.props.urls.filter(url => url.status === this.state.selected)
  }

  renderTableRows () {
    const { rowsPerPage, page } = this.state
    const urls = this.setUrls()

    if (urls.length === 0) {
      return this.renderNoUrlsWithChosenStatus()
    }

    const urlsToRender = this.state.sortBySubmittedAt === 'DESC' ? urls.slice().reverse() : urls

    return urlsToRender.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((url, index) => {
      return (
        <Fragment key={url.id}>
          <MediaQuery minWidth={992}>
            <UrlTableRow
              submittedUrl={url}
              gridTemplateColumns={this.state.gridTemplateColumns}
            />
          </MediaQuery>
          <MediaQuery maxWidth={992}>
            <MobileUrlTableRow
              submittedUrl={url}
              index={index}
            />
          </MediaQuery>
        </Fragment>
      )
    })
  }

  renderNoUrlsWithChosenStatus () {
    return (
      <tr className='text-center'>
        <td className='pt-16'>You don't have any urls with this status</td>
      </tr>
    )
  }

  renderNoUrlsMessage () {
    return (
      <tr className='text-center'>
        <td className='pt-16'>You have no imported URLs. Try our complimentary service that creates listings on your behalf, using URLs you submit from your website</td>
      </tr>
    )
  }

  renderTablePagination () {
    return (
      <TablePagination
        rowsPerPageOptions={[12, 25, 50]}
        component='div'
        count={this.setUrls().length}
        rowsPerPage={this.state.rowsPerPage}
        page={this.state.page}
        onPageChange={this.handleChangePage}
        onRowsPerPageChange={this.handleChangeRowsPerPage}
        labelDisplayedRows={({ from, to, count }) => `Showing ${from}-${to} of ${count}`}
      />
    )
  }

  render () {
    const headers = [
      { title: 'URL' },
      { title: 'Submitted', onClick: this.handleSortBySubmittedAt },
      { title: 'Status' },
      { title: 'Rejection reason' },
      { title: 'Cancel' }
    ]

    const urlCount = this.setUrls().length

    // Preserve the "view as seller" context (admins only) when navigating back
    // to the Listings page, which uses the `id` query string convention.
    const listingsPath = this.props.sellerId
      ? `/dashboard/listings?id=${this.props.sellerId}`
      : '/dashboard/listings'

    return (
      <div className='max-w-[1296px] mb-64'>
        <div>
          <div className='flex mt-24'>
            <a className='text-midnight-black-80 font-light pb-10 mr-30 px-16' href={buildUrl(listingsPath)}> Listings </a>
            <div className='text-midnight-black font-semibold px-16 pb-10 border-b-4 border-midnight-black'> Imported URLs </div>
          </div>
          <hr className='border-0 mt-0 h-px bg-midnight-black-20 [@media(max-width:400px)]:mb-16' />

          <div className='flex justify-between items-center mt-24 pb-16 [@media(max-width:992px)]:flex-col-reverse [@media(max-width:992px)]:items-start'>
            <div className='w-3/5 flex justify-start items-center gap-20 [@media(max-width:992px)]:w-full [@media(max-width:992px)]:justify-between'>
              <UrlsDropdownFilter
                onChange={this.handleSelectChange}
                value={this.state.selected}
              />
            </div>
            <div className='[@media(max-width:992px)]:w-full [@media(max-width:992px)]:pb-20 [@media(max-width:992px)]:my-10'>
              <PinkLinkButton className='mr-24 [@media(max-width:992px)]:mr-10' content={['Create listing']} href={buildUrl('/listings/new')} />
              <GrayLinkButton content={['Import URL']} href={buildUrl('/listings/import')} />
            </div>
          </div>

          <p className='text-size-l'>{this.state.selected} URLs ({urlCount})</p>

          <TableContainer style={{ maxWidth: '1300px' }}>
            <Table aria-label='simple table'>
              <TableHead
                headers={headers}
                gridTemplateColumns={this.state.gridTemplateColumns}
                currentSelected='Submitted'
                className='[@media(max-width:992px)]:hidden'
              />
              <tbody className='table-records'>
                {this.renderTableRows()}
              </tbody>
            </Table>

            {urlCount === 0 ? null : this.renderTablePagination()}
          </TableContainer>
        </div>
      </div>
    )
  }
}

export default ImportedUrlsContainer
